import { Grid, useMediaQuery } from "@mui/material";
import { BooleanField, DateField, Labeled, ReferenceField, TextField } from "react-admin";

import { settings } from "app";
import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import { SectionTitle } from "features/SectionTitle";
import SecuredComponent from "server/security/SecuredComponent";
import EditTransportDialog from "./components/EditTransportDialog";
import EditFinalReportDialog from "./components/EditFinalReportDialog";

const EducationSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Данни за обучение"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Факултетен номер">
            <TextField
              source="facultyNumber"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Външен номер на студент">
            <TextField
              source="externalStudentId"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Специалност">
            <ReferenceField
              label="Специалност"
              source="specialityId"
              reference={administrationRequests.getSpecialitiesSelect()}
            >
              <TextField
                label="Име"
                source="name"
                emptyText="-"
              />
            </ReferenceField>
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Тип визита">
            <ReferenceField
              source="type"
              reference={erasmusRequests.getMobilityTypesSelect()}
            >
              <TextField
                source="nameBg"
                emptyText="-"
              />
            </ReferenceField>
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Желае общежитие">
            <BooleanField
              source="wantsDormitory"
              sx={{ width: "fit-content" }}
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        />

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Зелен транспорт">
            <BooleanField
              source="isGreenTransport"
              sx={{ width: "fit-content" }}
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Споделен транспорт">
            <BooleanField
              source="isSharedTransport"
              sx={{ width: "fit-content" }}
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <SecuredComponent permission={permissions.canManageErasmusCampaigns}>
            <EditTransportDialog />
          </SecuredComponent>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Подаден финален отчет">
            <BooleanField
              source="finalReportSubmitted"
              sx={{ width: "fit-content" }}
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <SecuredComponent permission={permissions.canManageErasmusCampaigns}>
            <EditFinalReportDialog />
          </SecuredComponent>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        />
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Начало на отсъствието">
            <DateField
              source="absenceStartDate"
              locales="bg-BG"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Край на отсъствието">
            <DateField
              source="absenceEndDate"
              locales="bg-BG"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default EducationSection;
